import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

import type { IPhoneNumber } from "@/components/formControls";

export const phoneUtil = PhoneNumberUtil.getInstance();

/**
 * converts phone number string from server to phone dropdown
 * @param value phone number like "+98-9141231234"
 * @returns {IPhoneNumber}
 */
export function toPhone(value?: string | null): IPhoneNumber {
  if (!value) {
    return { code: "+98", number: "" };
  }
  const splitValue = value.split("-");

  const code = splitValue?.[0] || "";
  const number = splitValue?.[1] || "";

  return { code, number: formatNumber({ code, number }) };
}

/**
 * Encodes a phone number by concatenating the country code and phone number with a hyphen.
 * @param value - An object containing the country code and phone number of a phone number.
 * @returns A string representing the encoded phone number.
 */
export function encodePhone(value: IPhoneNumber): string {
  return value.number === ""
    ? ""
    : `${value.code || "+98"}-${value.number.replaceAll(/\s/g, "")}`;
}

/**
 * convert phone number value to INTERNATIONAL format (+98 937 989 4747)
 * @param value phone number object
 * @returns
 */
export function formatNumber(value: IPhoneNumber) {
  const code = value.code || "+98";

  try {
    return phoneUtil
      .format(
        phoneUtil.parseAndKeepRawInput(`${code}${value.number}`, code),
        PhoneNumberFormat.INTERNATIONAL,
      )
      .replace(code, "")
      .trim();
  } catch {
    return value.number;
  }
}

/**
 * indicate if the phone is valid or not
 * @param value phone number object
 * @returns return undefined when an error ocurred. for example when the length of number is too short
 */
export function isPhoneValid(value: IPhoneNumber): boolean | undefined {
  const code = value.code || "+98";

  try {
    return phoneUtil.isValidNumber(
      phoneUtil.parse(`${code}${value.number}`, code),
    );
  } catch {
    return undefined;
  }
}
